import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const AIInputLogo: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.49935 20.3337L9.05041 18.3407C8.66961 16.6502 7.34948 15.3301 5.659 14.9493L3.66602 14.5003L5.659 14.0514C7.34948 13.6706 8.66961 12.3505 9.05041 10.66L9.49935 8.66699L9.94829 10.66C10.3291 12.3505 11.6492 13.6706 13.3397 14.0514L15.3327 14.5003L13.3397 14.9493C11.6492 15.3301 10.3291 16.6502 9.94829 18.3407L9.49935 20.3337Z'
        stroke='url(#paint0_linear_10879_32780)'
        strokeWidth='1.25'
        strokeLinejoin='round'
      />
      <path
        d='M16.166 12.0003L15.8453 10.5768C15.5733 9.36929 14.6304 8.42633 13.4229 8.15433L11.9993 7.83366L13.4229 7.51299C14.6304 7.24099 15.5733 6.29803 15.8453 5.09055L16.166 3.66699L16.4867 5.09055C16.7587 6.29804 17.7016 7.24099 18.9091 7.51299L20.3327 7.83366L18.9091 8.15433C17.7016 8.42633 16.7587 9.36928 16.4867 10.5768L16.166 12.0003Z'
        stroke='url(#paint1_linear_10879_32780)'
        strokeWidth='1.25'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_10879_32780'
          x1='7.1173'
          y1='4.80347'
          x2='14.7124'
          y2='20.0262'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_10879_32780'
          x1='7.1173'
          y1='4.80347'
          x2='14.7124'
          y2='20.0262'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AIInputLogo;
